import React from "react";
import {
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonMenuButton,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { useHistory } from "react-router-dom";
import { rootPath } from "../Utils";

import QRIcon from "../assets/icon/svgicons/flavoriaQR.svg";

interface Props {
  subtitle: string;
  loggedIn: boolean;
  onLoginRequest: () => void;
}
const FlavoriaHeaderBar: React.FC<Props> = (props: Props) => {
  const history = useHistory();

  return (
    <IonHeader>
      <IonToolbar>
        <IonButtons slot="start">
          <IonMenuButton></IonMenuButton>
        </IonButtons>
        <IonTitle>
            {props.subtitle}
            {import.meta.env.MODE !== "production" && (
              <span style={{ fontSize: "0.65em", opacity: 0.7, marginLeft: "0.4em" }}>Beta</span>
            )}
        </IonTitle>
        <IonButtons slot="end">
          <IonButton style={{ minWidth: "6rem", "--background": "var(--ion-color-primary)", "--background-hover": "var(--ion-color-primary)", "--border-radius": "8px" }} onClick={() => {
            if (props.loggedIn) {
              history.push(`${rootPath}/qr`);
            } else {
              props.onLoginRequest();
            }
          }}>
            <IonIcon
              style={{ color: "white" }}
              size="large"
              icon={QRIcon}
            />
          </IonButton>
        </IonButtons>
      </IonToolbar>
    </IonHeader>
  );
};

export default FlavoriaHeaderBar;
